import { LayoutDashboard, Sparkles } from "lucide-react";
import { usePortalExperience, type PortalExperience } from "@/lib/portal-experience";
import { cn } from "@/lib/utils";

const choices: readonly {
  id: PortalExperience;
  label: string;
  accessibleLabel: string;
  icon: typeof LayoutDashboard;
}[] = [
  {
    id: "classic",
    label: "Classic",
    accessibleLabel: "Use Classic portal",
    icon: LayoutDashboard,
  },
  {
    id: "workspace",
    label: "Preview",
    accessibleLabel: "Use Workspace Preview",
    icon: Sparkles,
  },
];

export function PortalExperienceSwitcher({ compact = false }: Readonly<{ compact?: boolean }>) {
  const { experience, setExperience } = usePortalExperience();

  return (
    <div
      aria-label="Portal experience"
      className={cn(
        "grid grid-cols-2 rounded-lg border border-sidebar-border bg-background/40 p-1",
        compact ? "w-full" : "min-w-48",
      )}
    >
      {choices.map((choice) => {
        const Icon = choice.icon;
        const active = experience === choice.id;
        return (
          <button
            key={choice.id}
            type="button"
            aria-label={choice.accessibleLabel}
            aria-pressed={active}
            onClick={() => setExperience(choice.id)}
            className={cn(
              "flex items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-[0.68rem] font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              active
                ? "bg-primary/15 text-primary"
                : "text-muted-foreground hover:bg-sidebar-accent hover:text-foreground",
            )}
          >
            <Icon className="size-3.5" aria-hidden="true" />
            {choice.label}
          </button>
        );
      })}
    </div>
  );
}
